define.alias("ember-cli-string-helpers/helpers/uppercase", "media/helpers/uppercase");